import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Client-side navigation leaves the scroll position untouched, so following a
 * nav link from halfway down one page lands you halfway down the next.
 *
 * Only forward navigation resets. Back and forward (POP) keep whatever position
 * the browser restored, which is what people expect from those buttons, and a
 * URL carrying a #hash scrolls to that element instead — the points of unity
 * and demands both render anchorable ids.
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") return;

    if (hash) {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) {
        target.scrollIntoView();
        return;
      }
    }

    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
}

export default ScrollToTop;
